/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import { connect } from '../../components/LandingPageDataTable';
import Localized from '../../../shared/components/Localized';

const columns = [
  {
    title: 'ID',
    key: 'id',
    sizeLarge: 1,
    sizeMedium: 1,
    sizeSmall: 2,
    render: (row) => {
      if (row.isGeneralMessage) {
        return (
          <Link
            key={row.id}
            to={{
              pathname: `/generalmessages/${row.id}`,
              state: { modal: true }
            }}
          >
            <div>{row.id}</div>
          </Link>
        );
      } else {
        return (
          <Link
            key={row.id}
            to={{
              pathname: `/incidents/${row.id}`,
              state: { modal: true }
            }}
          >
            <div>{row.id}</div>
          </Link>
        );
      }
    }
  },

  {
    title: <Localized modelKey='subject' modelAttribute='header' modelName='bucketedList' />,
    key: 'incident',
    render: (row) => {
      if(row.isGeneralMessage) {
        return <span> {row.subject} </span>;
      } else {
        return (
          row.IncidentImpacts.map((incidentImpact, index) => {
            if (index === row.IncidentImpacts.length - 1) {
              return <Localized modelName={'incidentImpactType'} modelKey={incidentImpact.type} modelAttribute={'serviceIssue'} key={index} />;
            }
            return <span key={index} ><Localized modelName={'incidentImpactType'} modelKey={incidentImpact.type} modelAttribute={'serviceIssue'} />, </span>;
          })
        )
      }
    } ,
    sizeLarge: 3,
    sizeMedium: 4,
    sizeSmall: 7
  },
  {
    title: <Localized modelKey='instances' modelAttribute='header' modelName='bucketedList' />,
    key: 'instances',
    render: (row) => {
      if (row.isGeneralMessage) {
        return <span> <Localized modelKey='informational' modelAttribute='label' modelName='statusKey' /> </span>;
      } else {
        return (
          row.instanceKeys.map((instanceKey, index) => {
            if (index > 3) {
              return;
            }
            else if (index == 3) {
              return <span key={index}> .... </span>;
            }
            else if (index === row.instanceKeys.length - 1) {
              return <Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} key={index} />;
            }
            else {
              return <span key={index} ><Localized modelName={'instance'} modelKey={instanceKey} modelAttribute={'label'} />, </span>;
            }
          })
        )
    } },
    sizeLarge: 2,
    sizeMedium: 4,
    sizeSmall: 4,
  },
  {
    title: <Localized modelKey='services' modelAttribute='header' modelName='bucketedList' />,
    key: 'services',
    render: (row) => {
      if (row.isGeneralMessage) {
        return <span> - </span>;
      } else {
        return (
          row.serviceKeys.map((serviceKey, index) => {
            if (index === row.serviceKeys.length - 1) {
              return <Localized modelName={'service'} modelKey={serviceKey} modelAttribute={'label'} key={index} />;
            }
            return <span key={index} ><Localized modelName={'service'} modelKey={serviceKey} modelAttribute={'label'} />, </span>;
          })
        )
      }
    } ,
    sizeLarge: 2,
    hideMedium: true,
    hideSmall: true,
  },
  {
    title: <Localized modelKey='status' modelAttribute='header' modelName='bucketedList' />,
    key: 'status',
    render: (row) => row.status,
    sizeLarge: 1,
    hideMedium: true,
    hideSmall: true,
  },
];

const incidentBuckets = [];
incidentBuckets.push({
  title: (rows) => `(${rows.length})`,
  partition: (rows) => rows,
  open: true
});

function filter() {
  return true;
}

export default connect(columns, incidentBuckets, filter);

